import React, { Component } from "react";
import classNames from "classnames";
import styles from "./templateToolbar.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeTemplateName } from "../template/actions";
import { openTemplateSettingsModal } from "../modals/actions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class TemplateToolbar extends Component {
  renderTooltip = (name, id, props) => (
    <Tooltip id={id} {...props} className="tooltip-btn">
      {name}
    </Tooltip>
  );

  render() {
    const templateNameClassNames = classNames("templateWrapper", {
      hidden: !this.props.fileUploaded,
    });

    return (
      <div className="templateToolbarWrapper">
        <div className={templateNameClassNames}>
          <div className="templateInputWrap">
            <div className="label">Template Name:</div>
            <input
              type="text"
              className="form-control"
              id="templateNameField"
              placeholder="Template Name"
              value={this.props.templateName}
              onChange={(e) => this.props.changeTemplateName(e.target.value)}
            />
          </div>

          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={(props) =>
              this.renderTooltip(
                "template options..",
                "template_options_id",
                props
              )
            }
          >
            <div className="optionButtonWrap">
              <a
                disabled={!this.props.fileUploaded}
                onClick={this.props.openTemplateSettingsModal}
                className="optionButton"
                data-placement="bottom"
                title="Template options"
                data-toggle="modal"
                data-target="#templateSettingsModal"
              >
                <small className="btn btn-sm btn-primary optionButton">
                  template options..
                </small>
              </a>
            </div>
          </OverlayTrigger>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    fileUploaded: state.dashboard.fileUploaded,
    templateName: state.template.templateName,
    pdfFileName: state.pdfViewer.pdfFileName,
    templateFileName: state.editor.templateFileName,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeTemplateName,
      openTemplateSettingsModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateToolbar);
